export class CropPlaneToolConfig {
}
CropPlaneToolConfig.A_color = 0x63ADF2;
CropPlaneToolConfig.B_color = 0x63ADF2;
CropPlaneToolConfig.C_color = 0x63ADF2;
CropPlaneToolConfig.D_color = 0x63ADF2;
CropPlaneToolConfig.ABLine_color = 0x63ADF2;
CropPlaneToolConfig.BCLine_color = 0x63ADF2;
CropPlaneToolConfig.CDLine_color = 0x63ADF2;
CropPlaneToolConfig.DALine_color = 0x63ADF2;
CropPlaneToolConfig.circle_color = 0x63ADF2;
//# sourceMappingURL=CropPlaneToolConfig.js.map